
import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PhoneOrderDialogContextType {
  isOpen: boolean;
  openPhoneOrderDialog: () => void;
  closePhoneOrderDialog: () => void;
  handleSuccess: () => void;
}

const PhoneOrderDialogContext = createContext<PhoneOrderDialogContextType>({
  isOpen: false,
  openPhoneOrderDialog: () => {},
  closePhoneOrderDialog: () => {},
  handleSuccess: () => {},
});

export const usePhoneOrderDialog = () => useContext(PhoneOrderDialogContext);

interface PhoneOrderDialogProviderProps {
  children: ReactNode;
}

export const PhoneOrderDialogProvider: React.FC<PhoneOrderDialogProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openPhoneOrderDialog = () => setIsOpen(true);
  const closePhoneOrderDialog = () => setIsOpen(false);
  
  const handleSuccess = () => {
    setIsOpen(false);
    // Additional success handling if needed
  };

  return (
    <PhoneOrderDialogContext.Provider value={{ 
      isOpen, 
      openPhoneOrderDialog, 
      closePhoneOrderDialog,
      handleSuccess
    }}>
      {children}
    </PhoneOrderDialogContext.Provider>
  );
};
